import React from 'react';
import './header.css'
import AdvertisementVideo from '../../assets/Etwpromo.mp4';
import './header.css';
import { Col } from 'reactstrap';

function Header() {
    
    return ( 
        <Col className="header">
            <div className="header__content">
                <p>Meet Etheware Space: Our Latest Breakthrough for Satellite Internet and Cloud Storage</p>
                <h1 className="ombre__text">
                    SHARE INTERNET CONNECTION FROM MILES AWAY
                </h1>
                <p>Share your satellite internet and cloud storage with people in your Group, get updates, message and talk privately and view real-time performance metrics such as download speed, latency, and uptime.</p>
                <h2>Anyone with your space account on their device can use your internet connection or cloud anywhere, anytime with your permission. .</h2>
                
                <div className="header-content__input">
                    <a href='https://espace.etheware.com/'><button className='wl-su_btn'>Get Started</button></a>
                </div>
            </div>

            <div className="header__image">
                <video src={AdvertisementVideo} alt='Etheware Space Ad' autoPlay loop muted loading="lazy"/>
            </div>
        </Col>
    )
}

export default Header;
